import { render, staticRenderFns } from "./SimilarStartups.vue?vue&type=template&id=6b1bc90f&scoped=true&"
import script from "./SimilarStartups.vue?vue&type=script&setup=true&lang=js&"
export * from "./SimilarStartups.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1bc90f",
  null
  
)

export default component.exports